import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
import {
  Grid,
  TextField,
  Paper,
  withStyles,
  Button,
  Select,
  MenuItem,
  FormHelperText,
  Tabs,
  Table,
  TableBody,
} from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import './styles/devicepage.css';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';
import * as Icons from '@material-ui/icons';
import ContentRow from './components/ContentRow';

class DevicesPage extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    // this.initData = this.initData;
    this.state = {
      tabId: 0,
      expandAll: false,
      open: false,
      isDisabled: false,
      search: null,
      data: {
        id: '',
        name: '',
        tenantId: '',
        deviceId: '',
        deviceType: '',
        purchasedDate: '',
        dateLastServiced: '',
        description: '',
        status: '',
        assignTo: '',
        firmwareVersion: '',
        devicePlace: '',
        property: null,
        category: '',
        manufacturer: '',
      },
      errorField: {
        name: false,
        tenantId: false,
        deviceId: false,
        deviceType: false,
        purchasedDate: false,
        devicePlace: false,
      },
    };
  }

  async componentDidMount() {
    const { filterOutStatus, offset, limit, search, sort, order, tenantIds } = this.props.device.toJS();
    await this.props.device.getDevices(filterOutStatus, offset, limit, search, sort, order, tenantIds);

    await this.props.deviceType.getDeviceTypeList(0, 0);
    this.props.tenant.resetSelected();

    const tenantPermission = localStorage.getItem('tenant_permission')
      ? JSON.parse(localStorage.getItem('tenant_permission'))
      : [];
    await this.props.tenant.getTenants(0, 0, null, null, null, tenantPermission);
    await this.initData(tenantPermission);
  }

  async initData(tenantPermission) {
    const { id } = this.props.match.params;
    const { devices, tenantIds } = this.props.device.toJS();
    let { tenants, selected } = this.props.tenant.toJS();

    const showDeviceData = devices.data.find((item) => item.id === +id);
    if (showDeviceData) {
      this.setState({
        data: {
          id: showDeviceData.id,
          name: showDeviceData.name || '-',
          tenantId: showDeviceData.tenantId || '',
          deviceId: showDeviceData.serial || '',
          deviceType: showDeviceData.version || '',
          purchasedDate: showDeviceData.purchasedDate
            ? moment(new Date(showDeviceData.purchasedDate)).format('YYYY-MM-DD')
            : '',
          dateLastServiced: showDeviceData.dateLastServiced || '',
          description: showDeviceData.description || '',
          // version: showDeviceData.version,
          status: showDeviceData.status,
          assignTo: showDeviceData.assignTo,
          firmwareVersion: showDeviceData.firmwareVersion || '',
          devicePlace: showDeviceData.place || '',
          manufacturer: showDeviceData.manufacturer || '',
          property:
            showDeviceData.deviceVersion && showDeviceData.deviceVersion.property
              ? JSON.parse(showDeviceData.deviceVersion.property)
              : null,
          category: showDeviceData.deviceVersion && showDeviceData.deviceVersion.category,
        },
      });

      // expland row
      (tenants.data || []).forEach((t) => {
        if (t.id === +showDeviceData.tenantId) {
          t.toggle = true;
        }
      });
      this.props.tenant.setData('tenants', tenants, false);
      this.onSearchChange(tenants);

      // select permission
      const selectedTenants = (tenants.data || []).filter((t) => t.id === +showDeviceData.tenantId);
      selectedTenants.forEach((t) => {
        const groups = (t.groups || [])
          .map((g) => {
            const subgroups = (g.subGroups || []).filter(
              (s) => showDeviceData.subgroupPermission && showDeviceData.subgroupPermission.includes(s.id),
            );
            if (subgroups.map((s) => s.groupId).includes(g.id)) {
              const data = {
                ...g,
                subGroups: subgroups,
              };
              return data;
            }
            return null;
          })
          .filter((val) => val);
        selected.push({
          tenantId: t.id,
          groups,
          checked: true,
        });
      });
      this.props.tenant.setData('selected', selected, false);
    } else {
      // auto select tenant
      const Ids = tenantIds && tenantIds.length === 1 ? tenantIds : tenantPermission;
      if ((tenants && tenants.data && tenants.data.length === 1) || Ids.length === 1) {
        (tenants.data || [])
          .filter((t) => Ids.includes(t.id))
          .forEach((t) => {
            this.setState((prevState) => {
              prevState.data['tenantId'] = t.id;
              return prevState;
            });

            t.toggle = true;
            selected.push({
              tenantId: t.id,
              groups: t.groups,
              checked: true,
            });
          });
        this.props.tenant.setData('tenants', tenants, false);
        this.props.tenant.setData('selected', selected, false);
        this.onSearchChange(tenants);
      }
    }
  }

  goBack() {
    this.props.device.setAction('action', true);
    this.props.history.goBack();
  }

  validateDeviceID = (value) => {
    let patt = new RegExp('[A-Za-z0-9#_-]', 'g');
    let matchList = value.match(patt);
    let res = '';
    (matchList || []).forEach((val) => {
      res += val;
    });
    return res;
  };

  handleChange = (e) => {
    const { data } = this.state;
    let { name, value } = e.target;
    this.clearErrorField(name);
    const res = name === 'deviceId' ? this.validateDeviceID(value) : value;
    this.setState((prevState) => {
      prevState.data[name] = res;
      return prevState;
    });
    if (name === 'deviceType') {
      const { deviceTypes } = this.props.deviceType.toJS();
      const deviceType = (deviceTypes.data || []).find((item) => item.id === value);
      this.setState((prevState) => {
        prevState.data['property'] = JSON.parse(deviceType.property);
        prevState.data['category'] = deviceType.category;
        prevState.data['devicePlace'] =
          data.category === 'EMERGENCY_BUTTON' && data.property && !data.property.localization ? data.devicePlace : '';
        return prevState;
      });
    }
  };

  handleChangeTenant = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      prevState.data[name] = +value;
      return prevState;
    });

    // set expland row
    let { tenants } = this.props.tenant.toJS();
    (tenants.data || []).forEach((t) => {
      if (t.id === +value) {
        t.toggle = true;
      }
    });
    this.props.tenant.setData('tenants', tenants, false);
    this.onSearchChange(tenants);

    // select tenant
    const { selected } = this.props.tenant.toJS();
    const tenantDatas = tenants.data.find((t) => t.id === +value);
    if (tenantDatas) {
      const foundTenant = selected.find((s) => s.tenantId === tenantDatas.id);
      if (!foundTenant) {
        selected.push({
          tenantId: tenantDatas.id,
          groups: tenantDatas.groups,
          checked: true,
        });
      } else {
        selected.forEach((select) => {
          if (select.tenantId === tenantDatas.id) {
            select.checked = true;
          }
        });
      }
    }

    if (selected.length > 1) {
      selected.forEach((select) => {
        if (select.tenantId !== +value) {
          select.checked = false;
        }
      });
    }

    this.props.tenant.setData('selected', selected, false);
  };

  validateTenant() {
    let checkTenantId = !this.state.data.tenantId ? true : false;
    this.setState({
      errorField: {
        tenantId: checkTenantId,
      },
    });

    return !checkTenantId;
  }

  validate() {
    const { data } = this.state;
    // const momentDate = moment();
    // const perDate = moment(data.purchasedDate);
    // let checkDate = perDate > momentDate ? true : false
    // if (!data.name || !data.deviceId || !data.deviceType || data.deviceType === 'NEW' || checkDate) {
    let checkName = !data.name ? true : false;
    // let checkTenantId = !data.tenantId ? true : false;
    let checkDeviceId = !data.deviceId ? true : false;
    let checkDeviceType = !data.deviceType || data.deviceType === 'NEW' ? true : false;
    let checkPurchasedDate = false;
    let checkDevicePlace =
      data.category === 'EMERGENCY_BUTTON' && data.property && !data.property.localization && !data.devicePlace
        ? true
        : false;

    if (data.purchasedDate) {
      const date = moment(data.purchasedDate, 'YYYY-MM-DD', true);
      const futureDate = moment();
      checkPurchasedDate = !(date.isValid() && date.isSameOrBefore(futureDate));
    } else {
      checkPurchasedDate = false;
    }

    this.setState({
      errorField: {
        name: checkName,
        // tenantId: checkTenantId,
        deviceId: checkDeviceId,
        deviceType: checkDeviceType,
        purchasedDate: checkPurchasedDate,
        devicePlace: checkDevicePlace,
      },
    });
    // return false;
    // }
    // else {
    //   this.setState({
    //     errorField: {
    //       name: false,
    //       deviceId: false,
    //       deviceType: false,
    //       purchasedDate: false
    //     }
    //   });
    // }
    return !(
      checkName ||
      // checkTenantId ||
      checkDeviceId ||
      checkDeviceType ||
      checkPurchasedDate ||
      checkDevicePlace
    );
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
    if (key === 'tenantId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          tenantId: false,
        },
      });
    }
    if (key === 'deviceId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          deviceId: false,
        },
      });
    }
    if (key === 'deviceType') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          deviceType: false,
        },
      });
    }
    if (key === 'purchasedDate') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          purchasedDate: false,
        },
      });
    }
    if (key === 'devicePlace') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          devicePlace: false,
        },
      });
    }
  }

  onStep = (tabId) => {
    if (this.validate()) {
      this.setState({ tabId });
    }
  };

  handleCreateDevice = async (data) => {
    const { t } = this.props;
    if (this.validateTenant()) {
      try {
        const { selected } = this.props.tenant.toJS();
        const tenant = selected.find((s) => s.tenantId === +data.tenantId);
        const subgroupIds = [];
        if (tenant) {
          (tenant.groups || []).forEach((g) => {
            if (g.subGroups.length > 0) {
              g.subGroups.forEach((val) => {
                subgroupIds.push(val.id);
              });
            }
          });
        }

        const result = await this.props.device.createDevice(data, subgroupIds);
        if (result.statusCode === 200) {
          Swal.fire({
            html: `<h4>${t('create_success')}`,
            type: 'success',
          }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              this.props.history.push('../devices');
            }
          });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.message || `${t('failed_to_create')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({
            html: `<h4>${t('failed_to_create')}<br/>${e.error.message}`,
            type: 'error',
          });
        }
      }
    } else {
      Swal.fire({
        html: `<h4>${t('please_select_permission')}`,
        type: 'warning',
      });
    }
  };

  handleEditDevice(data) {
    const { t } = this.props;

    if (this.validateTenant()) {
      const { id } = this.props.match.params;
      const { devices } = this.props.device.toJS();
      const { selected } = this.props.tenant.toJS();

      const tenant = selected.find((s) => s.tenantId === +data.tenantId);
      const subgroupIds = [];
      if (tenant) {
        (tenant.groups || []).forEach((g) => {
          if (g.subGroups.length > 0) {
            g.subGroups.forEach((val) => {
              subgroupIds.push(val.id);
            });
          }
        });
      }

      const deviceData = devices.data.find((item) => item.id === +id);
      if (deviceData && deviceData.tenantId !== +data.tenantId) {
        const hasPatient = deviceData.patient;
        const titleHasPatient = `${t('device_assigned_to')}"${deviceData.assignTo}"<br>${t('are_you_sure_to_unassign_device')}`;

        Swal.fire({
          html: `<h4>${hasPatient ? titleHasPatient : t('edit_device')}`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: `${t('yes')}`,
          cancelButtonText: `${t('no')}`,
          reverseButtons: true,
          customClass: {
            container: 'my-swal',
          },
        }).then(async (result) => {
          if (result.value) {
            try {
              data.status = 'ACTIVATE_OFF';
              if (data.category === 'EMERGENCY_BUTTON' && data.property && !data.property.localization) {
                data.status = 'ACTIVATE_ON';
              }

              const result = await this.props.device.updateDevice(data, subgroupIds);
              if (result.statusCode === 200) {
                Swal.fire({
                  html: `<h4>${t('update_success')}`,
                  type: 'success',
                }).then(async (resultSuccess) => {
                  if (resultSuccess.value) {
                    this.props.device.setAction('action', true);
                    this.props.history.push('../../devices');
                  }
                });
              }
            } catch (e) {
              if (e.statusCode === 401) {
                clearLocalStorage();
                window.location.href = '/login';
              } else if (e.statusCode === 400) {
                const msg = e.error.message || `${t('failed_to_update')}`;
                Swal.fire({ html: `<h4>${msg}`, type: 'error' });
              } else {
                Swal.fire({
                  html: `<h4>${t('failed_to_update')}`,
                  type: 'error',
                });
              }
            }
          }
        });
      } else {
        Swal.fire({
          html: `<h4>${t('edit_device')}`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: `${t('yes')}`,
          cancelButtonText: `${t('no')}`,
          reverseButtons: true,
          customClass: {
            container: 'my-swal',
          },
        }).then(async (result) => {
          if (result.value) {
            try {
              const result = await this.props.device.updateDevice(data, subgroupIds);
              if (result.statusCode === 200) {
                Swal.fire({
                  html: `<h4>${t('update_success')}`,
                  type: 'success',
                }).then(async (resultSuccess) => {
                  if (resultSuccess.value) {
                    this.props.device.setAction('action', true);
                    this.props.history.push('../../devices');
                  }
                });
              }
            } catch (e) {
              if (e.statusCode === 401) {
                clearLocalStorage();
                window.location.href = '/login';
              } else if (e.statusCode === 400) {
                const msg = e.error.message || `${t('failed_to_update')}`;
                Swal.fire({ html: `<h4>${msg}`, type: 'error' });
              } else {
                Swal.fire({
                  html: `<h4>${t('failed_to_update')}`,
                  type: 'error',
                });
              }
            }
          }
        });
      }
    } else {
      Swal.fire({
        html: `<h4>${t('please_select_permission')}`,
        type: 'warning',
      });
    }
  }

  handleTabChange = (value) => {
    if (this.validate()) {
      this.setState({ tabId: value });
    }
  };

  handleChangeSearch = (event) => {
    const { value } = event.target;
    const { tenants } = this.props.tenant.toJS();

    this.props.tenant.setSearch(value);
    this.onSearchChange(tenants);
  };

  onSearchChange = (tenants) => {
    const { searchText } = this.props.tenant.toJS();

    const search = searchText && searchText.toLowerCase();
    let searchResult = tenants;
    if (search && search.length > 0) {
      const tmp = (tenants.data || []).filter((tenant) => {
        if (tenant.name.toLowerCase().includes(search)) {
          return true;
        } else if (tenant.groups && tenant.groups.length > 0) {
          const found = tenant.groups.find((group) => {
            if (group.name.toLowerCase().includes(search)) {
              return true;
            } else if (group.subGroups && group.subGroups.length > 0) {
              return group.subGroups.find((subgroup) => subgroup.name.toLowerCase().includes(search));
            }
            return false;
          });
          return found;
        }
        return false;
      });

      searchResult = { data: tmp };
    }

    this.props.tenant.setData('displayedTenants', searchResult, false);
  };

  handleToggle = (id) => {
    let { tenants } = this.props.tenant.toJS();
    (tenants.data || []).forEach((t) => {
      if (t.id === id) {
        t.toggle = !t.toggle;
      }
    });
    this.props.tenant.setData('tenants', tenants, false);
    this.onSearchChange(tenants);
  };

  handleExpandAll = (task) => {
    let { tenants } = this.props.tenant.toJS();
    (tenants.data || []).forEach((t) => {
      if (task === 'expand-all') {
        t.toggle = true;
      }
      if (task === 'collapse-all') {
        t.toggle = false;
      }
    });
    this.props.tenant.setData('tenants', tenants, false);
    this.onSearchChange(tenants);
  };

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data, tabId, isDisabled } = this.state;
    const { deviceTypes, loading } = this.props.deviceType.toJS();
    const { displayedTenants, searchText } = this.props.tenant.toJS();
    const expands = (displayedTenants.data || []).filter((t) => t.toggle);
    const expandAll = expands.length === (displayedTenants.data || []).length;

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_device')} />
          <Grid style={{ marginTop: 15 }}>
            <Tabs
              value={tabId}
              name='tab'
              indicatorColor='primary'
              textColor='primary'
              TabIndicatorProps={{
                style: {
                  display: 'none',
                },
              }}
            >
              <Button
                id='0'
                className={tabId === 0 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(0)}
              >
                {t('device_info')}
              </Button>
              <Button
                id='1'
                className={tabId === 1 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(1)}
              >
                {t('permission')}
              </Button>
            </Tabs>
          </Grid>
          {tabId === 0 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_type')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                  <Select
                    value={data.deviceType}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'deviceType',
                      id: 'deviceType',
                    }}
                  >
                    {(deviceTypes.data || []).map((val) => (
                      <MenuItem fullwidth='true' key={val.id} value={val.id}>
                        {`${val.name || 'deviceType'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.deviceType : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('name')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='name'
                  name='name'
                  fullWidth
                  value={data.name}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 255 }}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.name : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.name : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_id')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='deviceId'
                  name='deviceId'
                  fullWidth
                  value={data.deviceId}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 128 }}
                  variant='outlined'
                  margin='dense'
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.deviceId : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_place')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='devicePlace'
                  name='devicePlace'
                  fullWidth
                  value={data.devicePlace}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 255 }}
                  variant='outlined'
                  margin='dense'
                  placeholder={t('device_place_placeholder')}
                  error={!data.reset ? this.state.errorField.devicePlace : false}
                  disabled={
                    data.property && !data.property.localization && data.category === 'EMERGENCY_BUTTON' ? false : true
                  }
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.devicePlace : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('manufacturer')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='manufacturer'
                  name='manufacturer'
                  fullWidth
                  value={data.manufacturer}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.manufacturer : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('purchased_date')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='purchasedDate'
                  name='purchasedDate'
                  type='date'
                  // defaultValue="2017-05-24"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  value={data.purchasedDate || ''}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.purchasedDate : true}
                  id='component-error-text'
                >
                  {t('invalid_format')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('firmware_version')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='firmwareVersion'
                  name='firmwareVersion'
                  fullWidth
                  value={data.firmwareVersion}
                  onChange={this.handleChange}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[ก-๙]/g, '');
                  }}
                  inputProps={{ maxLength: 100 }}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('description')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='description'
                  name='description'
                  fullWidth
                  value={data.description}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 100 }}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12}>
                <div className={classes.buttons}>
                  <Button variant='contained' color='primary' onClick={() => this.onStep(1)} className={classes.button}>
                    {t('next')}
                  </Button>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={this.goBack}>
                    {t('cancel')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
          {tabId === 1 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid container item xs={12} sm={12} className={classes.mainContain}>
                <Grid container item xs={6} sm={6}>
                  <TextField
                    required
                    id='search'
                    name='search'
                    fullWidth
                    value={searchText || ''}
                    onChange={(e) => this.handleChangeSearch(e)}
                    inputProps={{ maxLength: 255 }}
                    variant='outlined'
                    margin='dense'
                    placeholder={t('search')}
                  />
                </Grid>
                <Grid container item xs={6} sm={6} justify='flex-end'>
                  {expandAll ? (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('collapse-all')}>
                      <Icons.ExpandLess />
                      {t('collapse_all')}
                    </Button>
                  ) : (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('expand-all')}>
                      <Icons.ExpandMore />
                      {t('expand_all')}
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} className={classes.mainContain}>
                <Table>
                  <TableBody>
                    {(displayedTenants.data || []).map((row) => (
                      <ContentRow
                        row={row}
                        key={row.id}
                        data={data}
                        handleChangeTenant={this.handleChangeTenant}
                        handleToggle={this.handleToggle}
                        disabled={isDisabled}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={() => this.onStep(0)}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => this.handleCreateDevice(data)}
                    className={classes.button}
                  >
                    {t('save')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data, tabId, /*expandAll,*/ isDisabled } = this.state;
    const { deviceTypes, loading } = this.props.deviceType.toJS();
    const { displayedTenants, searchText } = this.props.tenant.toJS();

    const expands = (displayedTenants.data || []).filter((t) => t.toggle);
    const expandAll = expands.length === (displayedTenants.data || []).length;

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_device')} />
          <Grid style={{ marginTop: 15 }}>
            <Tabs
              value={tabId}
              name='tab'
              indicatorColor='primary'
              textColor='primary'
              TabIndicatorProps={{
                style: {
                  display: 'none',
                },
              }}
            >
              <Button
                id='0'
                className={tabId === 0 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(0)}
              >
                {t('device_info')}
              </Button>
              <Button
                id='1'
                className={tabId === 1 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(1)}
              >
                {t('permission')}
              </Button>
            </Tabs>
          </Grid>
          {tabId === 0 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_type')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                  <Select
                    value={data.deviceType}
                    onChange={this.handleChange}
                    error={!data.reset ? this.state.errorField.deviceType : false}
                    inputProps={{
                      name: 'deviceType',
                      id: 'deviceType',
                    }}
                  >
                    {(deviceTypes.data || []).map((val) => (
                      <MenuItem fullwidth='true' key={val.id} value={val.id}>
                        {`${val.name || 'deviceType'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.deviceType : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('name')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='name'
                  name='name'
                  fullWidth
                  value={data.name}
                  // value={data.serial}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 255 }}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.name : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.name : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_id')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='deviceId'
                  name='deviceId'
                  fullWidth
                  value={data.deviceId}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 128 }}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.deviceId : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.deviceId : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_place')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='devicePlace'
                  name='devicePlace'
                  fullWidth
                  value={data.devicePlace}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 255 }}
                  variant='outlined'
                  margin='dense'
                  placeholder={t('device_place_placeholder')}
                  error={!data.reset ? this.state.errorField.devicePlace : false}
                  disabled={
                    data.property && !data.property.localization && data.category === 'EMERGENCY_BUTTON' ? false : true
                  }
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.devicePlace : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('manufacturer')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='manufacturer'
                  name='manufacturer'
                  fullWidth
                  value={data.manufacturer}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                />
                {/* <FormHelperText
                    error
                    hidden={
                      !data.reset ? !this.state.errorField.manufacturer : true
                    }
                    id="component-error-text"
                  >
                    {t('required_field')}
                  </FormHelperText> */}
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('purchased_date')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='purchasedDate'
                  name='purchasedDate'
                  type='date'
                  // defaultValue="2017-05-24"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  value={moment(data.purchasedDate).format('YYYY-MM-DD') || ''}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.purchasedDate : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.purchasedDate : true}
                  id='component-error-text'
                >
                  {t('invalid_format')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('date_last_service')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='dateLastServiced'
                  name='dateLastServiced'
                  type='date'
                  // defaultValue="2017-05-24"
                  required
                  className={classes.textField}
                  value={moment(data.dateLastServiced).format('YYYY-MM-DD') || ''}
                  onChange={this.handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('firmware_version')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='firmwareVersion'
                  name='firmwareVersion'
                  fullWidth
                  value={data.firmwareVersion}
                  onChange={this.handleChange}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[ก-๙]/g, '');
                  }}
                  inputProps={{ maxLength: 100 }}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('description')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='description'
                  name='description'
                  fullWidth
                  value={data.description}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 100 }}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              {data.status === 'NEW' ? (
                ''
              ) : (
                <React.Fragment>
                  <Grid item xs={12} sm={2}>
                    <FormInputLabel label={t('status')} />
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                      <Select
                        value={data.status}
                        onChange={this.handleChange}
                        inputProps={{
                          name: 'status',
                          id: 'status',
                        }}
                      >
                        <MenuItem value='ACTIVATE_ON'>ACTIVATE ON</MenuItem>
                        <MenuItem value='ACTIVATE_OFF'>ACTIVATE OFF</MenuItem>
                        <MenuItem value='DEACTIVATE'>DEACTIVATE</MenuItem>
                      </Select>
                    </Paper>
                  </Grid>
                </React.Fragment>
              )}
              <Grid item xs={12}>
                <div className={classes.buttons}>
                  <Button variant='contained' color='primary' onClick={() => this.onStep(1)} className={classes.button}>
                    {t('next')}
                  </Button>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={this.goBack}>
                    {t('cancel')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
          {tabId === 1 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid container item xs={12} sm={12} className={classes.mainContain}>
                <Grid container item xs={6} sm={6}>
                  <TextField
                    required
                    id='search'
                    name='search'
                    fullWidth
                    value={searchText || ''}
                    onChange={(e) => this.handleChangeSearch(e)}
                    inputProps={{ maxLength: 255 }}
                    variant='outlined'
                    margin='dense'
                    placeholder={t('search')}
                  />
                </Grid>
                <Grid container item xs={6} sm={6} justify='flex-end'>
                  {expandAll ? (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('collapse-all')}>
                      <Icons.ExpandLess />
                      {t('collapse_all')}
                    </Button>
                  ) : (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('expand-all')}>
                      <Icons.ExpandMore />
                      {t('expand_all')}
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} className={classes.mainContain}>
                <Table>
                  <TableBody>
                    {(displayedTenants.data || []).map((row) => (
                      <ContentRow
                        row={row}
                        key={row.id}
                        data={data}
                        handleChangeTenant={this.handleChangeTenant}
                        handleToggle={this.handleToggle}
                        disabled={isDisabled}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={() => this.onStep(0)}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => this.handleEditDevice(data)}
                    className={classes.button}
                  >
                    {t('save')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { data, tabId, expandAll } = this.state;
    const { deviceTypes, loading } = this.props.deviceType.toJS();
    const { displayedTenants, searchText } = this.props.tenant.toJS();
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('device_info')} />
          <Grid style={{ marginTop: 15 }}>
            <Tabs
              value={tabId}
              name='tab'
              indicatorColor='primary'
              textColor='primary'
              TabIndicatorProps={{
                style: {
                  display: 'none',
                },
              }}
            >
              <Button
                id='0'
                className={tabId === 0 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(0)}
              >
                {t('device_info')}
              </Button>
              <Button
                id='1'
                className={tabId === 1 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(1)}
              >
                {t('permission')}
              </Button>
            </Tabs>
          </Grid>
          {tabId === 0 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_type')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                  <Select value={data.deviceType} disabled>
                    {(deviceTypes.data || []).map((val) => (
                      <MenuItem fullwidth='true' key={val.id} value={val.id}>
                        {`${val.name || 'deviceType'}`}
                        {/* {`${val.name || 'deviceType'} (${val.name ||'device id'})`} */}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('name')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='name'
                  name='name'
                  fullWidth
                  value={data.name}
                  // value={data.serial}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_id')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='deviceId'
                  name='deviceId'
                  fullWidth
                  value={data.deviceId}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('device_place')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='devicePlace'
                  name='devicePlace'
                  fullWidth
                  value={data.devicePlace}
                  inputProps={{ maxLength: 255 }}
                  variant='outlined'
                  margin='dense'
                  placeholder={t('device_place_placeholder')}
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('manufacturer')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='manufacturer'
                  name='manufacturer'
                  fullWidth
                  value={data.manufacturer}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('purchased_date')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='purchasedDate'
                  name='purchasedDate'
                  type='date'
                  className={classes.textField}
                  fullWidth
                  value={moment(data.purchasedDate).format('YYYY-MM-DD') || ''}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('date_last_service')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='dateLastServiced'
                  name='dateLastServiced'
                  type='date'
                  className={classes.textField}
                  value={moment(data.dateLastServiced).format('YYYY-MM-DD') || ''}
                  fullWidth
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('firmware_version')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='firmwareVersion'
                  name='firmwareVersion'
                  fullWidth
                  value={data.firmwareVersion}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('description')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='description'
                  name='description'
                  fullWidth
                  value={data.description}
                  disabled
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              {data.status === 'NEW' ? (
                ''
              ) : (
                <React.Fragment>
                  <Grid item xs={12} sm={2}>
                    <FormInputLabel label={t('status')} />
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                      <Select value={data.status} disabled>
                        <MenuItem value='ACTIVATE_ON'>ACTIVATE ON</MenuItem>
                        <MenuItem value='ACTIVATE_OFF'>ACTIVATE OFF</MenuItem>
                        <MenuItem value='DEACTIVATE'>DEACTIVATE</MenuItem>
                      </Select>
                    </Paper>
                  </Grid>
                </React.Fragment>
              )}

              <Grid item xs={12}>
                <div className={classes.buttons}>
                  <Button variant='contained' color='primary' onClick={() => this.onStep(1)} className={classes.button}>
                    {t('next')}
                  </Button>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={this.goBack}>
                    {t('cancel')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
          {tabId === 1 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid container item xs={12} sm={12} className={classes.mainContain}>
                <Grid container item xs={6} sm={6}>
                  <TextField
                    required
                    id='search'
                    name='search'
                    fullWidth
                    value={searchText || ''}
                    inputProps={{ maxLength: 255 }}
                    variant='outlined'
                    margin='dense'
                    placeholder={t('search')}
                    disabled
                  />
                </Grid>
                <Grid container item xs={6} sm={6} justify='flex-end'>
                  {expandAll ? (
                    <Button className={classes.btnExpand} disabled>
                      <Icons.ExpandLess />
                      {t('collapse_all')}
                    </Button>
                  ) : (
                    <Button className={classes.btnExpand} disabled>
                      <Icons.ExpandMore />
                      {t('expand_all')}
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} className={classes.mainContain}>
                <Table>
                  <TableBody>
                    {(displayedTenants.data || []).map((row) => (
                      <ContentRow
                        row={row}
                        key={row.id}
                        data={data}
                        handleChangeTenant={this.handleChangeTenant}
                        handleToggle={this.handleToggle}
                        disabled={true}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={() => this.onStep(0)}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button variant='contained' color='primary' onClick={() => this.goBack()} className={classes.button}>
                    {t('cancel')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/devices/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  spaceTop: {
    marginTop: '10px',
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    width: '120px',
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  btnExpand: {
    width: '150px',
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  selectOption: {
    '& fieldset': {
      top: '-2px',
      bottom: '2px',
    },
    '& svg': {
      top: 'calc(50% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '5px',
    },
    '&:hover, &:focus': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },
  muitiSelect: {
    // marginTop: "10px",
    width: '100%',
    padding: 20,
    borderRadius: '5px',
    borderStyle: 'solid',
    borderColor: 'gray',
    borderWidth: '1px',
    maxHeight: 500,
    position: 'relative',
    overflow: 'auto',
  },
  muitiSelectNoBorder: {
    marginTop: '35px',
    marginBottom: '35px',
  },
  footerTable: {
    display: 'flex',
    justifyContent: 'end',
  },
  tabs: {
    width: '48%',
    color: theme.palette.text.secondary,
    fontWeight: 400,
    borderBottom: `3px solid ${theme.palette.text.hint}`,
    borderRadius: 0,
    margin: 4,
  },
  tabsActive: {
    width: '48%',
    color: theme.palette.primary.main,
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    borderRadius: 0,
    margin: 4,
  },
});

export const page = inject('device', 'deviceType', 'subGroup', 'tenant')(observer(DevicesPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
page.propTypes = {
  history: PropTypes.object,
};
